import colors from '../colors';
import {
  btn_xs, svg_md, shadow_box_md, btn_li, btn_md, btn_c_link,
} from '../styleGuide';

export default {
  clearSearchBtn: {
    position: 'absolute',
    left: 'auto',
    right: 0,
    bottom: '16px',
    top: 'auto',
    ...btn_xs,
    background: 'none',
    fill: colors.gray,
  },
  clearSearchBtnHov: {
    fill: colors.darkGray,
  },
  clearSearchIcon: {
    ...svg_md,
  },
  inputContainer: {
    position: 'relative',
    zIndex: 100,
  },
  optionsContainer: {
    position: 'absolute',
    background: colors.offWhite,
    border: '1px solid rgba(0,0,0,0.2)',
    padding: '8px',
    maxHeight: '250px',
    overflow: 'auto',
    width: '100%',
    ...shadow_box_md,
  },
  option: {
    ...btn_li,
    paddingLeft: 0,
    ...btn_md,
    ...btn_c_link.base,
  },
  optionHov: {
    ...btn_c_link.hover,
  },
};
